<template>
	<div class="problem" :is="problem" :truth="false" :fail="false"></div>
</template>
<script type="text/javascript">
	import Quiz from './scripts/QuizClass';
	const $functions = require('./scripts/functions');
	export default{
		name: "problem-component",
		props: {
			quiz: {},
		},
		created(){
		},
		computed:{
			problem() {
				let quiz = new Quiz({
					problem: this.quiz.problem,
					vars: this.quiz.vars,
					operations: [],
					explains: [],
					units: '',
					solution: '',
				}, '', false);
				return {
		 			template: $functions.tag('div', quiz.problem, {class: 'problem'}),
		 			name: 'Problem',
		 			created() {
		 			},
		 			data() {
		 				return {fail: false, truth: false, submited: ''};
		 			},
		 			methods: {

		 			},
		 			watch:{
		 				submited(n,o) {
		 				}
		 			}
				}
			},
		}
	};
</script>